var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
/**
 * A js file containing exports that relate to
 * the functionality and styles of the TextInputBase component.
 * The component uses styled-components to render.
 * @object
 * @param {object} props - React props.
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

var SearchIcons = styled.i(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 20px;\n  display: flex;\n  position: relative;\n  left: 0.625rem;\n  top: 1.7rem;\n"])));
export default SearchIcons;